import { Text } from 'rebass';
import styled from 'styled-components';

export default styled(Text)`
  line-height: 1.5;
`;



// WEBPACK FOOTER //
// ./src/app/components/content/index.js